<template>
  <b-modal
    v-if="isCreatePropertyModalOpen"
    v-model="isCreatePropertyModalOpen"
    :width="600"
    @close="onClose"
  >
    <v-form
      :data="form"
      method="post"
      :url="$laravel.route('api.properties.check')"
      @success="onSuccess"
    >
      <template #default="{ errors }">
        <div class="modal-card">
          <header class="modal-card-head">
            <p class="modal-card-title">
              {{ $t("new_property") }}
            </p>
          </header>
          <section class="modal-card-body">
            <v-form-address
              v-model="form"
              :title="$t('address')"
              :prefix="'address.'"
              :errors="errors"
            />

            <b-notification
              v-if="existingProperty"
              type="is-danger mt-4 is-light"
              :closable="false"
            >
              {{ $t('this') }}
              <router-link
                :to="{
                  name: 'properties.show.details',
                  params: { property: existingProperty.id },
                }"
                exact
              >
                {{ $t('property').toLowerCase() }}
              </router-link>
              {{ $t('already_exists') }}
              <router-link
                :to="{
                  name: 'properties.show.details',
                  params: { property: existingProperty.id },
                }"
                exact
              >
                {{ $t('click_here') }}
              </router-link>
            </b-notification>
          </section>

          <footer class="modal-card-foot is-justify-content-flex-end">
            <b-button
              :label="$t('cancel')"
              @click="onClose"
            />
            <button
              class="button is-primary"
              type="submit"
            >
              {{ $t("create") }}
            </button>
          </footer>
        </div>
      </template>
    </v-form>
  </b-modal>
</template>

<script>
import address from "./components/_address.vue";

export default {
  components: {
    "v-form-address": address,
  },
  props: {
    isShown: {
      type: Boolean,
      default: false,
    },
  },
  data(){
    return {
      isCreatePropertyModalOpen: this.isShown,
      form: {
        address_1: "",
        address_2: "",
        city:"",
        postal_code:"",
        province:"",
        country:"",
      },
      existingProperty: null,
    };
  },
  methods: {
    onClose() {
      this.isCreatePropertyModalOpen = false;
      this.existingProperty = null;
      this.form = {
        address_1: "",
        address_2: "",
        city:"",
        postal_code:"",
        province:"",
        country:"",
      };

      this.$emit("close");
    },
    onSuccess(response) {
      if (response.data.is_existing) {
        this.existingProperty = response.data.property;
      }

      if (! response.data.is_existing) {
        this.$router.push({
          name: "properties.create",
          query: {
            address:this.form.address_1,
            unit: this.form.address_2,
            city: this.form.city,
            postal_code: this.form.postal_code,
            province: this.form.province,
            country: this.form.country,
          },
        });
      }
    },
  },
};
</script>


